import { styled, Grid } from "@mui/material";

export const LandingPageWrapper = styled(Grid)({
  width: "100%",
  height: "100%",
  background: "#002035",
});
export const LandingPageWrapperMobile = styled("div")({
  display: "flex",
  padding: "28px 16px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  background: "#002035",
});
